import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { createVarint } from "./varint";
import { MAX_SCRIPT_BLOCK } from "./constants";
export function startUntrustedHashTransactionInputRaw(transport, newTransaction, firstRound, transactionData) {
  var bip143 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var overwinter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var additionals = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var p2 = bip143 ? additionals.includes("sapling") ? 0x05 : overwinter ? 0x04 : 0x02 : 0x00;
  return transport.send(0xe0, 0x44, firstRound ? 0x00 : 0x80, newTransaction ? p2 : 0x80, transactionData);
}
export function startUntrustedHashTransactionInput(_x, _x2, _x3, _x4) {
  return _startUntrustedHashTransactionInput.apply(this, arguments);
}

function _startUntrustedHashTransactionInput() {
  _startUntrustedHashTransactionInput = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(transport, newTransaction, transaction, inputs) {
    var bip143,
        overwinter,
        additionals,
        data,
        i,
        isDecred,
        _iteratorNormalCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        input,
        prefix,
        scriptBlocks,
        offset,
        blockSize,
        _i,
        scriptBlock,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bip143 = _args.length > 4 && _args[4] !== undefined ? _args[4] : false;
            overwinter = _args.length > 5 && _args[5] !== undefined ? _args[5] : false;
            additionals = _args.length > 6 && _args[6] !== undefined ? _args[6] : [];
            data = Buffer.concat([transaction.version, transaction.timestamp || Buffer.alloc(0), transaction.nVersionGroupId || Buffer.alloc(0), createVarint(transaction.inputs.length)]);
            _context.next = 6;
            return startUntrustedHashTransactionInputRaw(transport, newTransaction, true, data, bip143, overwinter, additionals);

          case 6:
            i = 0;
            isDecred = additionals.includes("decred");
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 11;
            _iterator = transaction.inputs[Symbol.iterator]();

          case 13:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 35;
              break;
            }

            input = _step.value;
            prefix = void 0;

            if (bip143) {
              prefix = Buffer.from([0x02]);
            } else {
              if (inputs[i].trustedInput) {
                prefix = Buffer.from([0x01, inputs[i].value.length]);
              } else {
                prefix = Buffer.from([0x00]);
              }
            }

            data = Buffer.concat([prefix, inputs[i].value, isDecred ? Buffer.from([0x00]) : Buffer.alloc(0), createVarint(input.script.length)]);
            _context.next = 20;
            return startUntrustedHashTransactionInputRaw(transport, newTransaction, false, data, bip143, overwinter, additionals);

          case 20:
            scriptBlocks = [];
            offset = 0;

            if (input.script.length === 0) {
              scriptBlocks.push(input.sequence);
            } else {
              while (offset !== input.script.length) {
                blockSize = input.script.length - offset > MAX_SCRIPT_BLOCK ? MAX_SCRIPT_BLOCK : input.script.length - offset;

                if (offset + blockSize !== input.script.length) {
                  scriptBlocks.push(input.script.slice(offset, offset + blockSize));
                } else {
                  scriptBlocks.push(Buffer.concat([input.script.slice(offset, offset + blockSize), input.sequence]));
                }

                offset += blockSize;
              }
            }

            _i = 0;

          case 24:
            if (!(_i < scriptBlocks.length)) {
              _context.next = 31;
              break;
            }

            scriptBlock = scriptBlocks[_i];
            _context.next = 28;
            return startUntrustedHashTransactionInputRaw(transport, newTransaction, false, scriptBlock, bip143, overwinter, additionals);

          case 28:
            _i++;
            _context.next = 24;
            break;

          case 31:
            i++;

          case 32:
            _iteratorNormalCompletion = true;
            _context.next = 13;
            break;

          case 35:
            _context.next = 41;
            break;

          case 37:
            _context.prev = 37;
            _context.t0 = _context["catch"](11);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 41:
            _context.prev = 41;
            _context.prev = 42;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 44:
            _context.prev = 44;

            if (!_didIteratorError) {
              _context.next = 47;
              break;
            }

            throw _iteratorError;

          case 47:
            return _context.finish(44);

          case 48:
            return _context.finish(41);

          case 49:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[11, 37, 41, 49], [42,, 44, 48]]);
  }));
  return _startUntrustedHashTransactionInput.apply(this, arguments);
}